import { BaseResponseAttributes } from "../attributes/base-attributes";
import { AddPricingGroupAttributes, PricingGroupAttributes } from "../attributes/pricing-group-attributes";
import BaseService from "./BaseService";
import { RestApiResponse } from "./RestApi";

export class PricingGroupService extends BaseService {
  static async getAllPricingGroup(): Promise<RestApiResponse<BaseResponseAttributes>> {
    return PricingGroupService.getApiClient().get(
      `admin/pricing-groups`
    );
  }

  static async getPricingGroupPaginate(): Promise<RestApiResponse<BaseResponseAttributes>> {
    return PricingGroupService.getApiClient().get(
      `admin/pricing-groups/paginate`
    );
  }

  static async addPricingGroup(
    data: AddPricingGroupAttributes
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    const url: string = `admin/pricing-groups/add`;

    const formData = new FormData();

    // Add text data
    Object.keys(data).forEach((key) => {
      formData.append(key, data[key]);
    });

    return PricingGroupService.getApiClient().sendFormData({
      method: "post",
      url: url,
      data: formData,
      headers: { "Content-Type": "multipart/form-data" },
    });
  }

  static async updatePricingGroup(
    pricingGroupId: number,
    data: PricingGroupAttributes
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    const url: string = `admin/pricing-groups/${pricingGroupId}/update`;

    const formData = new FormData();

    // Add text data
    Object.keys(data).forEach((key) => {
      formData.append(key, data[key]);
    });

    return PricingGroupService.getApiClient().sendFormData({
      method: "post",
      url: url,
      data: formData,
      headers: { "Content-Type": "multipart/form-data" },
    });
  }
  
}
export default PricingGroupService;
